import _get from 'lodash/get'

import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_PetHealthV1GetsafeDe } from '@flows/insurance/schemas'

const pure_breed = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('breed_type')]:
        BaseSchema_PetHealthV1GetsafeDe.shape.breed_type,
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_petHealth:steps.pure_breed.title',
          values: {
            pet_name: {
              type: 'dynamicValue',
              path: params.helperFunctions.getParamPath('pet_name'),
            },
          },
        },
      },
      {
        type: 'choice',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('breed_type'),
        options: [
          {
            value: 'pedigree',
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_petHealth:steps.pure_breed.pedigree',
            },
          },
          {
            value: 'crossbreed',
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_petHealth:steps.pure_breed.crossbreed',
            },
          },
        ],
      },
    ],
    subFlow: params.subFlow,

    nextStepConfig: {
      valueFunction: (flowValues) => {
        const breedType = _get(flowValues, params.helperFunctions.getParamPath('breed_type'))
        const petType = _get(flowValues, params.helperFunctions.getParamPath('pet_type'))

        if (breedType === 'crossbreed') {
          if (petType === 'cat') {
            return 'pet_age'
          }
          return 'cross_breed_names'
        }
        return 'pure_breed_name'
      },
      valueToStepName: {
        pet_age: 'pet_age',
        cross_breed_names: 'cross_breed_names',
        pure_breed_name: 'pure_breed_name',
      },
    },
  }) as const satisfies AnyStepConfiguration

export default pure_breed
